import React, { forwardRef } from "react";
import cn from "classnames";
import s from "./style.module.css";
import { SubHeading, Note } from "../Elements";

const Vizualisation = (
  {
    title,
    note,
    source,
    subtitle,
    children,
    beforeChart,
    afterChart,
    size = "default",
  },
  ref
) => {
  const sizes = {
    default: null,
    large: cn(s.wideChart, s.chartLarge),
    xLarge: cn(s.wideChart, s.chartXLarge),
    fullwidth: cn(s.wideChart, s.chartFullWidth),
    fullscreen: cn(s.wideChart, s.chartFullscreen),
  };

  return (
    <div className={s.wrap}>
      {title && (
        <SubHeading className={subtitle ? s.hasSubtitle : ""}>
          {title}
        </SubHeading>
      )}
      {subtitle && <p className={s.subtitle}>{subtitle}</p>}

      {beforeChart && beforeChart}

      <div className={cn(s.chart, sizes[size])} ref={ref}>
        {children}
      </div>

      {afterChart && afterChart}

      {source && <Note>{source}</Note>}
      {note && <Note>{note}</Note>}
    </div>
  );
};
export default forwardRef(Vizualisation);
